$(function() {
  $('.tabbed-content--tabs button, .tabbed-content .mobileHeading button').click(function(e){
  	if(e) {
  		e.preventDefault();
  	}
  	$('.tabbed-content .mobileHeading button').removeClass('active');
  	$(this).addClass('active').siblings().removeClass('active');
  	$(this).parents('.container').find('.tabbed-content--content').removeClass('active');
  	$(this).parents('.container').find('.components-tab-'+($(this).attr('data-heading'))).addClass('active');
  });


  $('.tabbed-content .mobileAccordionHeader button').click(function(e){
  	if(e) {
  		e.preventDefault();
  	}
  	$('.tabbed-content .mobileAccordionHeader button').removeClass('active');
  	$(this).addClass('active');
  	$(this).parents('.container').find('.tabbed-content--content').removeClass('active');
  	$(this).parents('.container').find('.components-tab-'+($(this).attr('data-heading'))).addClass('active');
  	$('html, body').animate({
        scrollTop: ($(this).parents('.container').find('.components-tab-'+($(this).attr('data-heading'))).offset().top - 2*($('.docked-mobile-navigation-container').outerHeight()))
    }, 250);
  });

});